class DynamicHero {
  constructor() {
    this.banner = document.querySelector(".banner");
    this.wrapper = this.banner.closest(".wrapper");
    this.events();
  }

  events() {
    if (this.banner && this.wrapper) {
      const height = this.banner.offsetHeight;
      this.setHeights(height);
    }
  }

  setHeights(height) {
    this.banner.style.top = `-${height}px`;
    this.wrapper.style["margin-top"] = `${height}px`;
  }
}

export default DynamicHero;
